import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { DateTimePicker } from '../../../../../components/dateTimePicker/DateTimePicker';
import { DEFAULT_DATE } from '../../../../../components/common/Constants';
import { toDateString } from '../../../../../utils/TimeUtils';
import { WriteOffAllDayTable } from './WriteOffAllDayTable';
import './WriteOffAllDayModal.css';
import { WriteOffButton } from '../../../../../components/buttons/WriteOffButton';
import { getDayWriteOff, writeOffDay } from '../WarehouseService';
import { useAlert } from 'react-alert';

const WriteOffAllDayModal = ({ onWriteOff }) => {
    const { t } = useTranslation('warehouse');
    const alert = useAlert();
    const [show, setShow] = useState(false);
    const [records, setRecords] = useState(null);
    const [people, setPeople] = useState(null);
    const [missingProducts, setMissingProducts] = useState([]);
    const [date, setDate] = useState(null);

    const handleClose = () => {
        setShow(false);
        setRecords(null);
        setPeople(null);
        setMissingProducts([]);
    };

    const handleShow = () => setShow(true);

    const loadDay = (value) => {
        let writeOffDate = toDateString(value, DEFAULT_DATE);
        getDayWriteOff(writeOffDate)
            .then((response) => {
                setRecords(response.data.records);
                setPeople(response.data.people);
                setMissingProducts(response.data.missingProducts);
                setDate(writeOffDate)
            });
    };

    const writeOffAllDay = () => {
        let notEmpty = records.filter(it => it.writeOffAmount > 0)
        writeOffDay(notEmpty, date)
            .then(() => {
                alert.success(t('alert:writeOffSuccess'));
                onWriteOff();
                handleClose();
            })
            .catch(() => alert.error(t('alert:writeOffError')));
    };

    const getMissingProductsTitle = () => {
        return missingProducts.map((product, index) => (index + 1) + '. ' + product)
            .join('\n');
    }

    return (
        <>
            <button className={'button--main primary-button'} onClick={handleShow}>
                {t('common:buttons.writeOffAllDay')}
            </button>
            <Modal show={show} onHide={handleClose} backdrop="static" className={'modified-modal'}>
                <div className={'write-off-all-day-container center'}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('common:buttons.writeOffAllDay')}
                            <div className={'title-container'}>
                                <DateTimePicker value={null}
                                                onChange={loadDay}
                                                dateFormat={DEFAULT_DATE}
                                                showTime={false}>
                                </DateTimePicker>
                                {people != null ? <span>{t('monthMenu:menuDay')}: {people.dayOfMenu}</span> : <></>}
                                {missingProducts.length > 0
                                    ? <div>
                                        <span title={getMissingProductsTitle()}
                                              className={'alert-color'}>{t('warehouse:missingProducts')}</span>
                                    </div>
                                    : <></>}
                            </div>

                        </Modal.Title>
                        {people != null
                            ? <div className={'people-info-container'}>
                                <span>{t('monthMenu:littleOnes')} {people.littleOnes}</span>
                                <span>{t('monthMenu:olderKids')} {people.olderKids}</span>
                                <span>{t('monthMenu:preschoolers')} {people.preschoolers}</span>
                                <span>{t('monthMenu:workers')} {people.workers}</span>
                            </div>
                            : <></>}
                    </Modal.Header>
                    {records != null
                        ? <WriteOffAllDayTable records={records}></WriteOffAllDayTable>
                        : <></>}
                    {records != null
                        ? <div className={'center'}>
                            <WriteOffButton onClick={writeOffAllDay} />
                        </div>
                        : <></>}
                </div>
            </Modal>

        </>
    );
};

export default WriteOffAllDayModal;
